import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [status, setStatus] = useState("Signing you in…");
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        // As cookie fallback, also verify to fetch bearer via /auth/me
        // Store nothing sensitive; cookie handles session
        window.history.replaceState({}, "", "/dashboard");
        toast.success(`Welcome, ${data.name?.split(" ")[0] || "there"}!`);
        const pending = localStorage.getItem("bf_pending_invite");
        if (pending) { localStorage.removeItem("bf_pending_invite"); navigate(`/join/${pending}`, { replace: true }); return; }
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        setStatus("Sign-in failed. Redirecting…");
        setTimeout(() => navigate("/login", { replace: true }), 1200);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bf-glow">
      <div className="text-center">
        <div className="h-12 w-12 mx-auto rounded-full border-2 border-teal-500/30 border-t-teal-500 animate-spin" />
        <p className="mt-4 text-sm text-muted-foreground">{status}</p>
      </div>
    </div>
  );
}
